/*
  Busy state for the cart drawer / cart page.

  After an add, remove or quantity change the theme waits on /cart/change.js
  and then /cart?view=ajax before swapping in the new cart, with no feedback
  in between. This fades and locks .js-ajax-cart-content (see custom.css,
  .is-updating) from the moment the change starts until the new cart lands.
*/
(function () {
  var BUSY = 'is-updating';
  // +/- are left out: cart-qty-stepper.js lets them be clicked repeatedly and
  // then fires `change` on the input, which sets the busy state below.
  var TRIGGERS = '.js-cart-remove';
  var MAX_BUSY_MS = 10000; // never leave the cart locked if a request hangs
  var timer;

  function setBusy(on) {
    clearTimeout(timer);
    document.querySelectorAll('.js-ajax-cart-content').forEach(function (el) {
      el.classList.toggle(BUSY, on);
      el.setAttribute('aria-busy', on ? 'true' : 'false');
    });
    if (on) timer = setTimeout(function () { setBusy(false); }, MAX_BUSY_MS);
  }

  // Quantity +/-, remove, and typed quantities (capture: before the theme's handlers).
  document.addEventListener('click', function (e) {
    if (e.target.closest(TRIGGERS)) setBusy(true);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-item-qty]')) setBusy(true);
  }, true);

  // Every add-to-cart path ends in updateView, which then re-fetches the cart.
  var ajaxCart = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;
  if (ajaxCart) {
    var originalUpdateView = ajaxCart.updateView;
    ajaxCart.updateView = function () {
      setBusy(true);
      return originalUpdateView.apply(this, arguments);
    };
  }

  // Done when the theme swaps in the new cart HTML — or, when the cart empties,
  // just hides the form / shows the empty message (both inside the content,
  // which itself is never replaced, so it is the one element safe to observe).
  document.querySelectorAll('.js-ajax-cart-content').forEach(function (el) {
    new MutationObserver(function (mutations) {
      var finished = mutations.some(function (m) {
        return m.type === 'childList'
          ? m.target === el
          : m.target.matches('.js-cart-empty, .js-cart-form');
      });
      if (finished) setBusy(false);
    }).observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  });
})();
